import { buildQuoteProducts } from './quoteProducts';

export const poToPrincipalVendorOptions = ['Yes', 'No', 'Stock'];
export const poSalesStatusOptions = ['Closed', 'Pending', 'Open', 'In Transit'];

export const MAX_PO_INVOICES = 100;
let nextInvoiceKey = 0;
export const newPoInvoice = () => ({ _key: 'new-invoice-' + (++nextInvoiceKey), invoice_no: '', invoice_date: '', transporter_name: '', reference_number: '' });

export const QUOTE_ALREADY_CONVERTED = 'This quote has already been converted to PO Sales.';

export const getQuoteConversionBlockReason = quote => {
  if (quote?.has_po_sale === true) return QUOTE_ALREADY_CONVERTED;
  if (String(quote?.status || '').trim().toLowerCase() === 'lost') {
    return 'Lost quotes cannot be converted to PO Sales.';
  }
  return quote?.can_convert_to_po_sale === false ? QUOTE_ALREADY_CONVERTED : '';
};

export const buildPoSalesInitialValues = (quote = null) => {
  const safeQuote = quote ?? {};

  return {
    quote_id: safeQuote.id ?? '',
    system_quote_no: safeQuote.system_quote_no ?? '',
    offer_no: safeQuote.offer_no ?? '',
    offer_date: safeQuote.offer_date ?? '',
    expected_date: safeQuote.expected_date ?? '',
    customer_id: safeQuote.customer_id ?? '',
    customer_name: safeQuote.customer?.name ?? '',
    company_name: safeQuote.company?.name ?? '',
    branch_name: safeQuote.branch?.name ?? '',
    principal_name: safeQuote.principal?.name ?? '',
    category_name: safeQuote.category?.name ?? '',
    products: buildQuoteProducts(safeQuote).map(({ id, _key, ...product }) => product),
    remarks: safeQuote.remarks ?? '',
    status: 'Pending',
    po_number: '',
    po_release_date: '',
    po_received_date: '',
    po_amount: safeQuote.total ?? '',
    delivery_due_date: safeQuote.expected_date ?? '',
    po_to_principal_vendor: 'No',
    stock_reference_number: '',
    stock_reference_date: '',
    payment_term: '',
    transporter_name: '',
    transit_reference_number: '',
    transit_date: '',
    transit_freight: '',
    po_status: 'Pending',
  };
};
